import { Component } from "@angular/core";

@Component({
  selector: "app-contact-desktop",
  template: `
    <div class="component-wrapper">
      <h1>FALE COM A GENTE!</h1>
      <p><span class="bold">Fale diretamente</span> com nosso Vendedor pelo Whatsapp!</p>
      <app-falar-vendedor-button></app-falar-vendedor-button>
      <h2>NOSSOS PRODUTOS</h2>
      <app-lista-servicos></app-lista-servicos>
    </div>
  `,
  styles: [
    `
      .component-wrapper {
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      app-falar-vendedor-button {
        width: 100%;
      }

      .component-wrapper h1 {
        font-size: 1.2rem;
        text-align: center;
        line-height: 1.5rem;
      }

      h2 {
        font-size: 0.35rem;
        margin-top: 1.5rem;
        margin-bottom: 0.2rem;
      }

      .component-wrapper p {
        font-family: "Metronic Pro", sans-serif;
        font-size: 0.45rem;
        line-height: 0.6rem;
        text-align: center;
        font-style: italic;
      }

      .component-wrapper p .bold {
        font-family: "Metronic Pro", sans-serif;
        font-style: italic;
        font-weight: bold;
        font-size: 0.45rem;
      }
    `,
  ],
})
export class ContactDesktopComponent {}
